import { useState } from "react";
import HandyPlaceholder, {
  mockSmartphones,
} from "../Placeholders/HandyPlaceholder";
import TabletPlaceholder, {
  mockTablets,
} from "../Placeholders/TabletPlaceholder";
import HardwareDetails from "./HardwareDetails";
import type { DeviceSelection } from "./HardwareDetails";

type HardwareSubTab = "smartphones" | "tablets" | "sim-only";

interface SelectedDevice {
  id: string;
  name: string;
  specs: string;
  price: number;
}

interface HardwareProps {
  onConfirm: (selection: DeviceSelection) => void;
  onNext: () => void;
}

function Hardware({ onConfirm, onNext }: HardwareProps) {
  const [activeHardwareTab, setActiveHardwareTab] =
    useState<HardwareSubTab>("smartphones");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDevice, setSelectedDevice] = useState<SelectedDevice | null>(
    null,
  );

  const smartphoneCount = mockSmartphones.reduce(
    (acc, group) => acc + group.devices.length,
    0,
  );
  const tabletCount = mockTablets.reduce(
    (acc, group) => acc + group.devices.length,
    0,
  );

  const handleDeviceConfirm = (selection: DeviceSelection) => {
    onConfirm(selection);
    setSelectedDevice(null);
  };

  const renderHardwareContent = () => {
    if (selectedDevice) {
      return (
        <HardwareDetails
          device={selectedDevice}
          onBack={() => setSelectedDevice(null)}
          onConfirm={handleDeviceConfirm}
        />
      );
    }

    switch (activeHardwareTab) {
      case "smartphones":
        return (
          <HandyPlaceholder
            searchQuery={searchQuery}
            onSelect={setSelectedDevice}
          />
        );
      case "tablets":
        return (
          <TabletPlaceholder
            searchQuery={searchQuery}
            onSelect={setSelectedDevice}
          />
        );
      case "sim-only":
        return <p>SIM Only - Auswahl (In Vorbereitung)</p>;
      default:
        return null;
    }
  };

  return (
    <div className="calculator__hardware-view">
      <header className="calculator__view-header">
        <h2>Hardware-Auswahl</h2>
      </header>

      {/* Search Bar */}
      {!selectedDevice && (
        <div className="calculator__search-wrapper">
          <input
            type="text"
            placeholder="Gerät suchen..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      )}

      {/* Sub-Tabs for Hardware */}
      <div className="calculator__sub-tabs">
        <button
          className={`calculator__sub-tab ${activeHardwareTab === "smartphones" ? "calculator__sub-tab--active" : ""} ${selectedDevice ? "calculator__sub-tab--disabled" : ""}`}
          onClick={() => !selectedDevice && setActiveHardwareTab("smartphones")}
          disabled={!!selectedDevice}
        >
          Smartphones{" "}
          <span className="calculator__count">{smartphoneCount}</span>
        </button>
        <button
          className={`calculator__sub-tab ${activeHardwareTab === "tablets" ? "calculator__sub-tab--active" : ""} ${selectedDevice ? "calculator__sub-tab--disabled" : ""}`}
          onClick={() => !selectedDevice && setActiveHardwareTab("tablets")}
          disabled={!!selectedDevice}
        >
          Tablets <span className="calculator__count">{tabletCount}</span>
        </button>
        <button
          className={`calculator__sub-tab ${activeHardwareTab === "sim-only" ? "calculator__sub-tab--active" : ""} ${selectedDevice ? "calculator__sub-tab--disabled" : ""}`}
          onClick={() => !selectedDevice && setActiveHardwareTab("sim-only")}
          disabled={!!selectedDevice}
        >
          SIM Only
        </button>
      </div>

      <div className="calculator__inner-content">
        {renderHardwareContent()}
        <div className="calculator__btn-next-container">
          <button className="calculator__btn-next" onClick={onNext}>
            Weiter zu Mobilfunk
          </button>
        </div>
      </div>
    </div>
  );
}

export default Hardware;
